import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'


import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';



class StockCardSheet extends Component{
    constructor(){
        super();
        this.save = this.save.bind(this)
        this.state={
            userId : "",
            user : {},
            criteria : {},
            list :{}
        }
        
    }

    componentDidMount(){
        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });

                    }.bind(this));
            }else{
                this.props.history.push("/login");
            }

        });
        var data = ref.child("Inventory").child("Sheets").child(this.props.match.params.id)
            data.on("value", function(snap){
                this.setState({
                    criteria : snap.val()
                })
            }.bind(this))

        var transaction = ref.child("StockCard").child("Sheets")
            transaction.on("value", function(snap){
                this.setState({
                    list : snap.val()
                })
            }.bind(this))    
    }

    save(e){
        e.preventDefault()
        console.log(this.state.list)
    }
    

    
          
    render() {

        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title=" Stock Card" />
                            <div className="block">
                                <form className="form-horizontal form-bordered" >
                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Sheet Dimension</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  type="text" value={this.state.criteria.dimension} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Sheet Length</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  type="text" value={this.state.criteria.length} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Sheet Thickness</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  type="text" value={this.state.criteria.thickness} />
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Sheet Color</label>
                                        <div className="col-md-4">
                                            <input className="form-control"  type="text" value={this.state.criteria.color} />
                                        </div>
                                    </div>

                                </form>
                                <table id="ecom-products" className="table table-bordered table-striped ">
                                    <thead>
                                        <tr>               
                                            <th className="text-center">Date</th>                        
                                            <th className="text-center">In/Out</th>
                                            <th className="text-center">Count</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {   
                                            this.state.list &&
                                            Object.keys(this.state.list).map(key => {
                                                let list = this.state.list[key]
                                                let criteria = this.state.criteria
                                                if (criteria.color === list.color && criteria.length === list.length && criteria.thickness === list.thickness && criteria.dimension === list.dimension){
                                                    return (<tr>
                                                                <td>
                                                                    {list.date}
                                                                </td>
                            
                                                                <td>
                                                                    {list.status}
                                                                </td>
                                                                <td>
                                                                    {list.count}
                                                                </td>

                                                            </tr>) 
                                                }
                                                
                                            })
                                        }
                                        
                                    </tbody>
                                </table>
                                               
                            </div>                                
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
      
        );
    }
}

export default  StockCardSheet;



// WEBPACK FOOTER //
// ./src/components/StockCardSheet.js